import React from 'react';
import { displaySuccess } from 'Helpers/FacetNotificationManager';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import View from './View';
import { useApexAdminPortalStateContext, useApexAdminPortalDispatchContext } from '../../ApexAdminPortalContext';
import { refreshAchRelationshipResource, setAchRelationshipResource } from '../../ApexAdminPortalActions';

const AchRelationship = () => {
  const { achRelationshipResource } = useApexAdminPortalStateContext();
  const apexDispatch = useApexAdminPortalDispatchContext();
  const { rootNodeProps, logEvent } = useEventTrackingLogEvent({ nodeName: 'ACH Relationship Details' });

  const onClickRefresh = async () => {
    await refreshAchRelationshipResource(achRelationshipResource, apexDispatch, () => {
      displaySuccess('Refreshed ACH Relationship');
    });
    logEvent('Click Refresh');
  };

  if (!achRelationshipResource) {
    return null;
  }

  return (
    <View
      resource={achRelationshipResource}
      onClose={() => setAchRelationshipResource(null, apexDispatch)}
      onClickRefresh={onClickRefresh}
      amplitudeRootNodeProps={rootNodeProps}
    />
  );
};

export default AchRelationship;
